export default __webpack_public_path__ + "static/media/bus.4f9b6c98.png";